export const oteljsVersion = '4.8.15';
